import { BaseEntity } from 'src/app/tools/models/baseEntity'
import { PartnerSite } from '../control-tables/partner-site-entity';
import { PartnerAnalysisGroup1 } from '../control-tables/partner-analysis-group1';
import { PartnerAnalysisGroup2 } from '../control-tables/partner-analysis-group2';
import { PartnerAnalysisGroup3 } from '../control-tables/partner-analysis-group3';
import { PartnerAnalysisGroup4 } from '../control-tables/partner-analysis-group4';
import { PartnerAnalysisGroup5 } from '../control-tables/partner-analysis-group5';
import { SalesChannel } from '../control-tables/sales-channel';
import { Bank } from '../control-tables/bank';
import { Warehouse } from './warehouse-entity';
import { Role } from './role-entity';
import { GeoArea } from '../control-tables/geo-area-entity';
import { Branch } from '../control-tables/branch-entity';
import { PriceList } from './price-list-entity';
import { PaymentTerm } from '../control-tables/payment-term';
import { ProductAttributeGroup } from '../control-tables/product-attribute-group';
import { ProductAttributeGroupParam } from '../control-tables/product-attribute-group-param';
import { Itinerary } from './itinerary-entity';
import { Visit } from './visit-entity';
import { marker } from 'src/app/tools/models/entities/marker';
import { Currency } from '../control-tables/currency';
import { GraphhopperCluster } from 'src/app/assabil-sales/models/dtos/graph-hopper/graphhopper-cluster';

export class Partner extends BaseEntity {

    partnerCode             : string;
    name                    : string; 
    partnerid               : number;
    partneridtypeCode       : string;
    partnerCategoryCode     : string;
    partnerCategorytypeCode : string;
    partnerStatusCode       : string;
    partnerClusterCode      : string; // temporary
    partnerCluster          : any; //PartnerCluster;
    geoArea                 : GeoArea;
    rank                    : number;
    streetName1             : string;
    city                    : string;
    state                   : string;
    country                 : string;
    email                   : string;

    branch                  : Branch;
    itinerary               : Itinerary;
    longitude               : number;
    latitude                : number;

    partnerSites            : PartnerSite[];


    name2                   : any;                                                       
    warehouse               : Warehouse;             
    role                    : Role;                  
    hold                    : any;                      	
    holdReason              : any;                
    lastVisitDate           : any;             
    lastSorderDate          : any;            
    lastSinvoiceDate        : any;                       
    num                     : any;                                   
    streetName2             : any;               
    extendedAddress         : any;           
    postalCode              : any;                
    phone1                  : any;                    
    phone2                  : any;                    
    fiscalId                : any;                  
    priceList               : PriceList;             
    vat1Exoneration         : any;           	
    vat2Exoneration         : any;           	
    fixedTaxExoneration     : any;       	
    paymentTerm             : PaymentTerm;           
    creditLimitCommercial   : any;   	
    creditBalanceCommercial : any; 	
    creditLimitFinancial    : any;     	
    creditBalanceFinancial : any;   	
    bank                    : Bank;                  
    salesChannel            : SalesChannel;          
   // partnerSubCluster       : PartnerSubCluster;     
    partnerAnalysisGroup1   : PartnerAnalysisGroup1; 
    partnerAnalysisGroup2   : PartnerAnalysisGroup2; 
    partnerAnalysisGroup3   : PartnerAnalysisGroup3; 
    partnerAnalysisGroup4   : PartnerAnalysisGroup4; 
    partnerAnalysisGroup5   : PartnerAnalysisGroup5; 
    productAttributeGroup1  : ProductAttributeGroup;
    productAttributeGroupParamCode : any; 
    productAttributeGroup2 : ProductAttributeGroup;

    productAttributeGroupParam : ProductAttributeGroupParam;

    currency                : Currency
    progressLevel           : number;
    //Transient
    visits                  : Visit[] = []
    point                   : marker;


    // Transient
    weight                  : number = 0;
    visible                 : boolean = false;
    cluster                 : GraphhopperCluster;
    rankInCluster           : number;
}

